// extracted by mini-css-extract-plugin
export default {"empty":"Empty_empty__99Yrv","image":"Empty_image__Q0GFZ","discover":"Empty_discover__4aiWz"};